import {addDays, parseISO, startOfWeek} from 'date-fns';
import {AppThunk} from '../../createStore';
import {
  acceptConnection,
  loadConnections,
  loadWorkspaceReservationsForConnections,
} from '../../data/connections/actions';
import {ConnectionUser} from '../../data/entities';
import {getStartOfTodayISOString} from '../../data/settings/selectors';

export const loadConnectionsWithWorkspaceReservations = (): AppThunk<Promise<void>> => async (dispatch, getState) => {
  const todayISOString = getStartOfTodayISOString(getState());
  const today = parseISO(todayISOString);
  const startOfThisWeek = startOfWeek(today);
  const from = startOfThisWeek.toISOString();
  const to = addDays(startOfThisWeek, 31).toISOString();
  await Promise.all([
    dispatch(loadConnections()).unwrap(),
    dispatch(loadWorkspaceReservationsForConnections({from, to})).unwrap(),
  ]);
};

export const acceptConnectionRequest =
  (user: ConnectionUser): AppThunk<Promise<void>> =>
  async (dispatch, getState) => {
    const todayISOString = getStartOfTodayISOString(getState());
    const today = parseISO(todayISOString);
    const startOfThisWeek = startOfWeek(today);
    const from = startOfThisWeek.toISOString();
    const to = addDays(startOfThisWeek, 31).toISOString();

    // This needs to happen in sequence, otherwise the workspaceReservations for the just accepted connection won't come
    // as the connection is still pending
    await dispatch(acceptConnection(user)).unwrap();
    await dispatch(loadWorkspaceReservationsForConnections({from, to})).unwrap();
  };
